export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8296.39d713a2.jpg";